const handleBeforeReload = (e) => {
  e.preventDefault();
  const message =
    'Are you sure you want to leave? All provided data will be lost.';
  e.returnValue = message;
  return message;
};

export default handleBeforeReload;